// src/modules/encomendas/EncomendasPage.js
import React from 'react';
// --- MUDANÇA: Importa o hook e o loading ---
import { useEncomendasAuth } from '../../context/EncomendasContext';
import { LoadingSpinner } from '../../components/LoadingSpinner';
// --- FIM MUDANÇA ---

/**
 * Este componente foi modificado para verificar a autorização do usuário
 * antes de carregar o iframe do módulo de encomendas.
 */
const EncomendasPage = () => {
  
  // --- MUDANÇA: Usa o hook para verificar autorização ---
  const { isAuthorized, isLoading } = useEncomendasAuth();

  if (isLoading) {
    return <LoadingSpinner text="Verificando autorização de acesso..." />;
  }

  if (!isAuthorized) {
    return (
      <div className="w-full h-full flex items-center justify-center p-8 text-center bg-white rounded-lg shadow-md">
        <div>
          <h2 className="text-2xl font-bold text-red-600 mb-4">Acesso Negado</h2>
          <p className="text-gray-700">
            O módulo de Encomendas é restrito. Você não está escalado como Comandante da Guarda
            ou Auxiliar no dia de hoje ou no dia anterior.
          </p>
          <p className="text-gray-500 mt-2">
            Caso isto seja um erro, contate o Administrador do sistema.
          </p>
        </div>
      </div>
    );
  }
  // --- FIM MUDANÇA ---


  // Se chegou aqui, está autorizado.
  const urlAppEncomendas = "/encomendas"; 

  return (
    <div 
        className="w-full h-full"
    >
      <iframe
        src={urlAppEncomendas}
        title="Módulo de Encomendas"
        style={{ width: '100%', height: 'calc(100vh - 80px)', border: 'none' }}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      />
    </div>
  );
};

export default EncomendasPage;